import React, { useState } from 'react';
    import { motion } from 'framer-motion';
    import SafeIcon from '../../common/SafeIcon';
    import { FiCalendar, FiFileText, FiHeart, FiCheckCircle, FiArrowRight } from 'react-icons/fi';
    import { useAuth } from '../../context/AuthContext';

    const journeySteps = [
      { name: 'Referral Sent', status: 'completed', date: 'Jul 10, 2023' },
      { name: 'Consultation', status: 'completed', date: 'Jul 15, 2023' },
      { name: 'Treatment Plan', status: 'active', date: 'Jul 20, 2023' },
      { name: 'Procedure', status: 'upcoming', date: 'Aug 5, 2023' },
      { name: 'Follow-up', status: 'upcoming', date: 'Aug 20, 2023' },
    ];

    const upcomingAppointments = [
      { type: 'Procedure with Dr. Smith', time: 'Aug 5, 2023 at 10:00 AM', location: 'Bright Smiles Ortho' },
      { type: 'Follow-up with Dr. Smith', time: 'Aug 20, 2023 at 2:30 PM', location: 'Bright Smiles Ortho' },
    ];

    const PatientDashboard = () => {
      const { user } = useAuth();

      return (
        <div className="bg-brand-light min-h-screen p-4 sm:p-6 lg:p-8">
          <div className="max-w-screen-2xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h1 className="text-3xl font-bold text-brand-primary">Patient Dashboard</h1>
              <p className="text-gray-500 mt-1">Welcome, {user?.firstName}. Track your treatment journey here.</p>
            </motion.div>

            {/* Treatment Journey Tracker */}
            <div className="mt-8 bg-white p-6 rounded-xl shadow-md border border-gray-100">
              <h2 className="text-xl font-bold text-brand-primary mb-6">Your Treatment Journey</h2>
              <div className="flex items-center">
                {journeySteps.map((step, index) => (
                  <React.Fragment key={step.name}>
                    <div className="flex flex-col items-center">
                      <div className={`w-12 h-12 rounded-full flex items-center justify-center
                        ${step.status === 'completed' ? 'bg-brand-secondary' : ''}
                        ${step.status === 'active' ? 'bg-brand-primary ring-4 ring-yellow-200' : ''}
                        ${step.status === 'upcoming' ? 'bg-gray-200' : ''}
                      `}>
                        <SafeIcon icon={FiCheckCircle} className={`h-6 w-6 ${step.status === 'upcoming' ? 'text-gray-400' : 'text-white'}`} />
                      </div>
                      <p className={`mt-2 text-center text-xs font-semibold ${step.status === 'active' ? 'text-brand-primary' : 'text-gray-600'}`}>{step.name}</p>
                      <p className="text-xs text-gray-400">{step.date}</p>
                    </div>
                    {index < journeySteps.length - 1 && (
                      <div className={`flex-1 h-1 mx-2 ${step.status === 'completed' ? 'bg-brand-secondary' : 'bg-gray-200'}`}></div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>

            <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Upcoming Appointments */}
              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h2 className="text-xl font-bold text-brand-primary mb-4">Upcoming Appointments</h2>
                <div className="space-y-4">
                  {upcomingAppointments.map((appt, i) => (
                    <motion.div 
                      key={i} 
                      className="flex items-center space-x-4 p-4 rounded-lg bg-brand-light"
                      whileHover={{ scale: 1.02 }}
                    >
                      <SafeIcon icon={FiCalendar} className="h-6 w-6 text-brand-primary" />
                      <div>
                        <p className="font-semibold text-gray-800">{appt.type}</p>
                        <p className="text-sm text-gray-500">{appt.time} at {appt.location}</p>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </div>

              {/* Quick Access */}
              <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <h2 className="text-xl font-bold text-brand-primary mb-4">Quick Access</h2>
                <div className="space-y-3">
                  <a href="#" className="flex justify-between items-center p-4 rounded-lg hover:bg-brand-light transition-colors">
                    <div className="flex items-center space-x-3">
                      <SafeIcon icon={FiFileText} className="text-brand-primary" />
                      <span className="font-semibold text-gray-700">View My Documents</span>
                    </div>
                    <SafeIcon icon={FiArrowRight} className="text-gray-400" />
                  </a>
                  <a href="#" className="flex justify-between items-center p-4 rounded-lg hover:bg-brand-light transition-colors">
                    <div className="flex items-center space-x-3">
                      <SafeIcon icon={FiHeart} className="text-brand-primary" />
                      <span className="font-semibold text-gray-700">Health & Wellness Blog</span>
                    </div>
                    <SafeIcon icon={FiArrowRight} className="text-gray-400" />
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      );
    };

    export default PatientDashboard;